import { SicComboBox } from './sic-combo-box';

/**
 * Custom event to dispatch parent element ID when the component is part of the active trail.
 */
export const _dispatchComboSelectionEvent = (self: SicComboBox) => {
  const activeKey = self?.activeKey;
  if (activeKey) {
    const options = {
      detail: { key: activeKey },
      bubbles: true,
      composed: true,
    };
    self.dispatchEvent(new CustomEvent('comboActiveKey', options));
  }
};
